<h5>Download {{downloadContent?.title}} - {{version}} <back-button></back-button></h5>
<p>
  <span [innerHTML]=downloadContent?.helpText></span>
</p>
<p>
<a *ngIf="downloadContent" class="btn btn-primary" (click)="downloadClick()">Download</a>
</p>
<back-button></back-button>
